import React, { useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2, Check, X } from "lucide-react";
import api from "../../lib/api";
import { SUB_STATUS } from "../../lib/perms";
import { KINDS, fmtAmount } from "./kinds";

const inp = "bg-[#191A1F] border border-[#D4AF37] text-[#F5F3ED] rounded-sm px-2 py-1 text-sm outline-none";

function Row({ e, reload }) {
  const [edit, setEdit] = useState(null);
  const save = async (body) => {
    try { await api.patch(`/stock/submissions/${e.id}`, body); toast.success("Diperbarui"); setEdit(null); reload(); } catch (err) { toast.error(err?.response?.data?.detail || "Gagal"); }
  };
  const del = async () => {
    if (!window.confirm(`Hapus ${e.product_name} dari daftar?`)) return;
    try { await api.delete(`/stock/submissions/${e.id}`); toast.success("Dihapus"); reload(); } catch (err) { toast.error(err?.response?.data?.detail || "Gagal"); }
  };
  const st = SUB_STATUS[e.status] || SUB_STATUS.available;
  return (
    <tr data-testid={`sub-row-${e.id}`} className="border-b border-[#35353B] align-top">
      <td className="px-4 py-3"><div className="text-[#F5F3ED]">{e.product_name}</div>
        <div className="text-[10px] uppercase tracking-widest text-[#D4AF37]">{KINDS[e.kind]?.label || "Game Currency"}{e.category_name ? ` · ${e.category_name}` : ""}</div></td>
      <td className="px-4 py-3 text-xs text-[#A8A8AD]">{e.game_name || "-"}<div>{e.server_name || "Semua server"}{e.faction ? ` · ${e.faction}` : ""}</div></td>
      <td className="px-4 py-3 text-right whitespace-nowrap">
        {edit ? <input data-testid={`sub-edit-qty-${e.id}`} type="number" min="1" value={edit.quantity} onChange={(x) => setEdit({ ...edit, quantity: x.target.value })} className={`${inp} w-28 text-right`} />
          : <span data-testid={`sub-qty-${e.id}`} className="font-bold text-[#D4AF37]">{fmtAmount(e)}</span>}</td>
      <td className="px-4 py-3 text-xs text-[#A8A8AD] max-w-[220px]">
        {edit ? <input data-testid={`sub-edit-notes-${e.id}`} maxLength={500} value={edit.notes} onChange={(x) => setEdit({ ...edit, notes: x.target.value })} className={`${inp} w-full`} /> : e.notes || "-"}</td>
      <td className="px-4 py-3">
        <button data-testid={`sub-status-${e.id}`} onClick={() => save({ status: e.status === "paused" ? "available" : "paused" })} title="Klik untuk ubah status"
          className={`inline-block px-2 py-1 border rounded-sm text-xs hover:opacity-80 ${st.cls}`}>{st.label}</button>
        <div className="text-[10px] text-[#A8A8AD] mt-1">{new Date(e.updated_at || e.created_at).toLocaleDateString("id-ID")}</div></td>
      <td className="px-4 py-3 text-right whitespace-nowrap">
        {edit ? <>
          <button data-testid={`sub-save-${e.id}`} onClick={() => save({ quantity: Number(edit.quantity), notes: edit.notes })} disabled={!(Number(edit.quantity) > 0)} className="text-[#35C78A] mr-3 disabled:opacity-40"><Check size={16} /></button>
          <button onClick={() => setEdit(null)} className="text-[#A8A8AD]"><X size={16} /></button></>
          : <>
            <button data-testid={`sub-edit-${e.id}`} onClick={() => setEdit({ quantity: e.quantity, notes: e.notes || "" })} className="text-[#A8A8AD] hover:text-[#D4AF37] mr-3 transition-colors"><Pencil size={15} /></button>
            <button data-testid={`sub-delete-${e.id}`} onClick={del} className="text-[#A8A8AD] hover:text-[#F06464] transition-colors"><Trash2 size={15} /></button></>}
      </td>
    </tr>
  );
}

export default function MyStockList({ entries, reload }) {
  return (
    <>
      <h2 className="text-xl font-bold text-[#F5F3ED] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>Daftar Stok Saya</h2>
      <div data-testid="my-stock-list" className="bg-[#202127] border border-[#35353B] rounded-lg overflow-x-auto">
        <table className="w-full text-sm min-w-[760px]">
          <thead className="bg-[#191A1F] border-b border-[#35353B]">
            <tr className="text-left text-[10px] uppercase tracking-widest text-[#A8A8AD]">
              <th className="px-4 py-3">Produk / Layanan</th><th className="px-4 py-3">Game / Server</th><th className="px-4 py-3 text-right">Jumlah / Kapasitas</th><th className="px-4 py-3">Catatan</th><th className="px-4 py-3">Status</th><th className="px-4 py-3" />
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => <Row key={e.id} e={e} reload={reload} />)}
            {entries.length === 0 && <tr><td colSpan="6" className="text-center py-10 text-[#A8A8AD]">Belum ada stok atau layanan yang dicatat.</td></tr>}
          </tbody>
        </table>
      </div>
    </>
  );
}
